var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav--wrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"pory--start"},[_vm._v("Pory")]),_c('span',{staticClass:"pory--end"},[_vm._v("Dex")])]),_c('about',{staticClass:"about"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }